export enum TipoDeNotificacaoEnum {
  GanhouPontos = 'Ganhou Pontos',
  Aniversario = 'Aniversário',
  ResgatouCartao = 'Resgatou Cartão',
  SentimosSuaFalta = 'Sentimos Sua Falta',
  CartaoCompleto = 'Cartão Completo',
  ClientePerdido = 'Cliente Perdido',

  CarrinhoAbandonado = 'Carrinho Abandonado',

  NovoCartao = 'Novo Cartão',
  PontosExpirar = 'Pontos Expirar',
  ConfirmarCartao = 'Confirmar Cartão',
  Marketing = 'Marketing',
  TesteCampanha = 'TesteCampanha',
  PedidoAlterado= 'Pedido Alterado',

  PedidoSaiuParaEntrega = 'Pedido Saiu Para Entrega',
  PedidoEmPreparacao= 'Pedido Em Preparação',
  PedidoPronto = 'Pedido Pronto',
  PedidoCancelado = 'Pedido Cancelado',
  PedidoEntregue = 'Pedido Entregue',
  PedidoRastreamentoUnico = 'Pedido Rastreamento Unico',
  ComandaFechada = 'Comanda Fechada',

  PedidoConfirmado = 'Pedido Confirmado',
  PedidoRealizadoCardapioOnline= 'Pedido Realizado Cardapio Online',
  Cardapio = 'Cardapio',
  LinkExtratoCartao = 'Link Extrato Cartao' ,
  ConfirmacaoPedido = 'ConfirmacaoPedido',
  CodigoConfirmacao = 'Codigo Confirmacao',
  MensagemSaudacaoWhatsappPedido = 'Mensagem Saudação Whatsapp Pedido',
  MensagemAusenciaWhatsappPedido = 'Mensagem Ausência Whatsapp Pedido',
  RespostaMia = 'Resposta Mia',
  FollowupMiaV3 = 'Follow-up Mia V3',
  RespostaAtendenteMiaV3 = 'Resposta Atendente Mia V3',
  SejaBemVindo = 'Bem Vindo',
  AvaliarPedido = 'Avaliar Pedido',

  PedidoAssociadoEntregador = 'Pedido Associado a Entregador',
  LinkPagamentoPedido = 'Link Pagamento do Pedido',
  PagamentoPendenteOnline  = 'Pagamento Pendente Online',
  PagamentoConfirmadoOnline  = 'Pagamento Confirmado Online'
}
